import React from 'react'
import readFile from './readFile'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import * as request from 'services/request'

export const UniqueCodesContainer = ({ children }) => (
  <div className='form-group darkPanel'>
    <div className='col-md-12'>
      <div className='portlet light'>
        <div className='portlet-title'>
          <div className='caption'>
            <span className='caption-subject bold font-green-haze uppercase'>
              <i
                className='glyphicon glyphicon-gift hidden-xs'
                style={{
                  alignSelf: 'flex-start',
                  marginTop: 8,
                  marginRight: 8
                }}
              />
              Unique Codes
            </span>
          </div>
        </div>
        <div className='portlet-body'>{children}</div>
      </div>
    </div>
  </div>
)

UniqueCodesContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export class ConfigureUniqueCodes extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      codesToUpload: [],
      showPreviewModal: false,
      totalCodesUploaded: null,
      remainingCodes: null,
      codesIssued: null
    }
    this.handleFileUpload = this.handleFileUpload.bind(this)
    this.handleShowPreviewModal = this.handleShowPreviewModal.bind(this)
    this.handleHidePreviewModal = this.handleHidePreviewModal.bind(this)
  }

  handleShowPreviewModal () {
    this.setState({ showPreviewModal: true })
  }

  handleHidePreviewModal () {
    this.setState({ showPreviewModal: false })
  }

  async handleFileUpload (e) {
    const files = e.target.files
    const file = files[0]
    const uniqueCodesFileName = file.name.replace(/\.[^/.]+$/, '')
    const codesToUpload = await readFile.readFileAsText(file)
    this.props.updateReduxField('uniqueCodesFileName', uniqueCodesFileName)
    this.props.updateReduxField('uniqueCodes', codesToUpload)

    this.setState({ codesToUpload })
  }

  async componentDidUpdate (prevProps) {
    if (prevProps.listId !== this.props.listId && this.props.listId) {
      const listDetails = await this.fetchExistingListDetails(this.props.listId)
      const {
        total: totalCodesUploaded,
        available: remainingCodes,
        used: codesIssued
      } = listDetails
      // Note: it is perfectly fine to use setState inside componentDidUpdate provided you have a break condition thus the linter ignore
      // https://stackoverflow.com/questions/30528348/setstate-inside-of-componentdidupdate
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        totalCodesUploaded,
        remainingCodes,
        codesIssued,
        codesToUpload: []
      })
    }
  }

  async fetchExistingListDetails (listId) {
    const response = await request.authorized(`/unique-code-lists/${listId}`)
    const { listDetails } = await response.json()
    return listDetails
  }

  render () {
    return (
      <UniqueCodesContainer>
        <div style={{ marginBottom: '30px' }}>
          <h3>Unique Codes List Management</h3>
          <span className='hidden-xs'>Hand out unique codes</span>
          <br />
          {this.state.codesToUpload.length <= 0 && !this.props.listId && (
            <span className='hidden-xs' style={{ fontWeight: 'bold' }}>
              No unique codes list attached
            </span>
          )}
          <br />
          {this.state.codesToUpload.length <= 0 && this.props.listId && (
            <span className='hidden-xs' style={{ fontWeight: 'bold' }}>
              List ID: {this.props.listId}
              <br />
              Total Codes Uploaded: {this.state.totalCodesUploaded}
              <br />
              Remaining Codes: {this.state.remainingCodes}
              <br />
              Codes Issued: {this.state.codesIssued}
            </span>
          )}
          {this.state.codesToUpload.length > 0 && (
            <button
              type='button'
              className='btn green-haze'
              onClick={this.handleShowPreviewModal}
              id='preview-codes-button'
            >
              <i className='fa fa-eye' />
              Preview Codes
            </button>
          )}
          <span style={{ float: 'right' }}>
            <div>
              <div className='fileinput fileinput-new input-group'>
                {!this.props.listId && (
                  <span className='input-group-addon btn btn-default btn-file green-haze'>
                    <span>
                      <i className='glyphicon glyphicon-plus' />
                      Import List
                    </span>
                    <input
                      type='file'
                      id='unique-code-file-input'
                      accept='.csv,.txt'
                      onChange={this.handleFileUpload}
                    />
                  </span>
                )}
                {this.props.listId && (
                  <span className='input-group-addon btn btn-default btn-file red-haze'>
                    <span>
                      <i className='glyphicon glyphicon-fire' />
                      Replace Existing List
                    </span>
                    <input
                      type='file'
                      id='unique-code-file-input'
                      accept='.csv,.txt'
                      onChange={this.handleFileUpload}
                    />
                  </span>
                )}
              </div>
            </div>
          </span>
        </div>
        <Modal
          show={this.state.showPreviewModal}
          onHide={this.handleHidePreviewModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Unique Codes To Upload</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ul>
              {this.state.codesToUpload.map((code, index) => (
                <li key={index}>{code}</li>
              ))}
            </ul>
          </Modal.Body>
        </Modal>
      </UniqueCodesContainer>
    )
  }
}

ConfigureUniqueCodes.propTypes = {
  updateReduxField: PropTypes.func.isRequired,
  listId: PropTypes.string
}

export default ConfigureUniqueCodes



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-unique-codes/index.js